import React, { ReactNode } from 'react';

import { themeData } from '@totem/styles/theme';

const styles = {
  title: {
    color: themeData.token.colorPrimary,
    fontSize: themeData.token.fontSize + 1,
    fontWeight: 700,
  },
};

type Props = {
  children: ReactNode;
  style?: React.CSSProperties;
};

const HeaderLabel = ({ children, style }: Props) => {
  return <div style={{ ...styles.title, ...style }}>{children}</div>;
};

export default HeaderLabel;
